<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom:20px; padding-top:100px;">Dedication</h1>
<p style="text-indent:00em;">To my boyfriend, Steven Gill, for giving me the courage to continue writing as well as help with the adult sections.</p><br/>
<p style="text-indent:00em;">Matthew Thompson for the encouragement.</p><br/>
<p style="text-indent:00em;">Inna – My boss for helping find my outlet, Steven Metzger, my brother for believing in me, my parents, Doug and Jenifer Metzger, for reading the manuscript and giving me tips.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?26c626ea